import { Button, TextField } from "@mui/material";
import { useState } from "react";
import { ConfirmDialog } from "../../components/ConfirmDialog";
import { useConfirmEmailChange, useRequestEmailChange } from "./api";
import { useNotify } from "../../app/useNotify";
import { errorMessageFor } from "../../api/client";

const looksLikeEmail = (value: string) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);

export function ChangeEmailDialog() {
  const [open, setOpen] = useState(false);
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const request = useRequestEmailChange();
  const confirm = useConfirmEmailChange();
  const notify = useNotify();

  function close() {
    setOpen(false);
    setEmail("");
    setOtp("");
    setOtpSent(false);
  }

  async function sendOtp() {
    try {
      await request.mutateAsync(email);
      setOtpSent(true);
      notify.success("Code sent to your email");
    } catch (error) {
      notify.error(errorMessageFor(error) ?? "Could not send the code.");
    }
  }

  return (
    <>
      <Button variant="outlined" onClick={() => setOpen(true)}>
        Change email
      </Button>
      <ConfirmDialog
        open={open}
        title="Change email"
        confirmLabel={otpSent ? "Change email" : "Send code"}
        busy={request.isPending || confirm.isPending}
        confirmDisabled={otpSent ? otp === "" : !looksLikeEmail(email)}
        onClose={close}
        onConfirm={async () => {
          if (!otpSent) {
            await sendOtp();
            return;
          }
          try {
            await confirm.mutateAsync({ email, otp });
            notify.success("Email changed");
            close();
          } catch (error) {
            notify.error(errorMessageFor(error) ?? "Could not change your email.");
          }
        }}
      >
        <TextField
          label="New email"
          value={email}
          onChange={(event) => setEmail(event.target.value)}
          disabled={otpSent}
          fullWidth
          margin="normal"
        />
        {otpSent && (
          <TextField
            label="One-time code"
            value={otp}
            onChange={(event) => setOtp(event.target.value)}
            fullWidth
            margin="normal"
          />
        )}
      </ConfirmDialog>
    </>
  );
}
